import partition from 'lodash/partition';

import { MapRecentSearchesToListItemsProps } from './types';

const compareFn = (a: any, b: any): number => {
  const isNumberA = !isNaN(a);
  const isNumberB = !isNaN(b);

  if (isNumberA && isNumberB) {
    return parseInt(a) - parseInt(b);
  }

  if (isNumberA || isNumberB) {
    return isNumberA ? -1 : 1;
  }

  return a.localeCompare(b);
};

export const dropdownOptionsSort = (
  arr: any[],
  selectedValues?: any[]
): any[] => {
  if (!selectedValues) {
    return [...arr].sort(compareFn);
  }
  const [selected, other] = partition(arr, (val) =>
    selectedValues.includes(val)
  );
  return [...selected, ...other.sort(compareFn)];
};

export const mapRecentSearchesToListItems = ({
  criteria,
  recentSearches,
}: MapRecentSearchesToListItemsProps): Array<
  Array<{ title?: string; value: any }>
> => {
  if (!recentSearches?.length) {
    return [];
  }

  const result: Array<Array<{ title?: string; value: any }>> = [];

  for (const { freeText, values } of recentSearches) {
    const entry: Array<{ title?: string; value: any }> = [];

    if (values) {
      for (const key in values) {
        const criterion = criteria?.find((c) => c.key === key);
        if (criterion) {
          let recentSearchValue = values[key];
          const renderOption = criterion.renderOption;

          if (renderOption) {
            if (Array.isArray(recentSearchValue)) {
              recentSearchValue = recentSearchValue.map((v, i) =>
                renderOption(v, i)
              );
            } else {
              recentSearchValue = renderOption(values[key]);
            }
          }

          entry.push({
            title: criterion.title || criterion.key,
            value: recentSearchValue,
          });
        }
      }
    }

    if (freeText) {
      entry.push({ value: freeText });
    }
    result.push(entry);
  }

  return result;
};
